export default defineNuxtPlugin(() => {

  useHead({
    script: [
      {
        key: 'consentmanager',
        type: 'text/javascript',
        defer: false,
        src: '/consentManager/consent-manager-unified.js',
      },
    ],
  });

});
